import { createContext, useContext, useEffect, type ReactNode } from 'react';
import { useBackendStatus } from '../hooks/useBackendStatus';

type BackendStatusValue = ReturnType<typeof useBackendStatus>;

const BackendStatusContext = createContext<BackendStatusValue | undefined>(undefined);

interface BackendStatusProviderProps {
  children: ReactNode;
}

export const BackendStatusProvider = ({ children }: BackendStatusProviderProps) => {
  const backendStatus = useBackendStatus();

  // Exponer el estado del backend globalmente
  useEffect(() => {
    (window as any).__backendStatus = backendStatus;
  }, [backendStatus]);

  return (
    <BackendStatusContext.Provider value={backendStatus}>
      {children}
    </BackendStatusContext.Provider>
  );
};

export const useBackendStatusContext = (): BackendStatusValue => {
  const context = useContext(BackendStatusContext);
  if (!context) {
    throw new Error('useBackendStatusContext must be used within a BackendStatusProvider');
  }
  return context;
};
